import React from 'react';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-blue-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-8">
          {/* Logo and Description */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <img 
                src="/custodiafxlogo.png" 
                alt="CustodiaFX Logo" 
                className="w-10 h-10 object-contain"
              />
              <span className="text-xl font-bold">
                Custodia<span className="text-green-400">FX</span>
              </span>
            </div>
            <p className="text-blue-200 leading-relaxed">
              Professional currency exchange services for businesses. 
              Trusted, secure, and competitive.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={() => document.getElementById('rates')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-blue-200 hover:text-white transition-colors"
                >
                  Live Rates
                </button>
              </li>
              <li>
                <button 
                  onClick={() => document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-blue-200 hover:text-white transition-colors"
                >
                  About Us
                </button>
              </li>
              <li>
                <button 
                  onClick={() => document.getElementById('process')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-blue-200 hover:text-white transition-colors"
                >
                  How It Works
                </button>
              </li>
              <li>
                <button 
                  onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-blue-200 hover:text-white transition-colors"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Contact Information</h3>
            <div className="space-y-2 text-blue-200">
              <p>CustodiaFX sp. z o.o.</p>
              <p>Marszałkowska 115</p>
              <p>00-102 Warszawa, Polska</p>
              <p>
                <a href="tel:+48506864786" className="hover:text-white transition-colors">
                  +48 506 864 786
                </a>
              </p>
              <p>
                <a href="mailto:office@custodiafx.com" className="hover:text-white transition-colors">
                  office@custodiafx.com
                </a>
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-blue-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="flex space-x-6">
              <button className="text-blue-200 hover:text-white transition-colors text-sm">
                Terms & Conditions
              </button>
              <button className="text-blue-200 hover:text-white transition-colors text-sm">
                Privacy Policy
              </button>
            </div>
            <p className="text-blue-200 text-sm">
              © {currentYear} CustodiaFX. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}